<template>
  <div
    class="modal fade"
    id="apply_his_data_modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
          <h4 class="modal-title" id="myModalLabel">历史数据</h4>
        </div>
        <!-- modal-body-->
        <div class="modal-body">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>类型</th>
                <th>表底数</th>
                <th>实际支付时间</th>
                <th>支付方式</th>
                <th>金额</th>
                <th>单价</th>
                <th>用电量</th>
                <th>公司</th>
                <th>备注</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in hisData" :key="index">
                <td>{{item.type_name}}</td>
                <td>{{item.current_reading}}</td>
                <td>{{item.current_time}}</td>
                <td>{{item.method_name}}</td>
                <td>{{item.money}}</td>
                <td>{{item.price}}</td>
                <td>{{item.used}}</td>
                <td>{{item.out_company || item.in_company}}</td>
                <td>{{item.remark}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var myChart, option;
export default {
  data() {
    return {
      hisData: [],
    };
  },
  props: ["msgStation"],
  mounted: function () {
    let self = this;
  },
  methods: {
    showHisData: function (hisData) {
      console.log("hisData", hisData);
      let self = this;
      var typeList = [
        "",
        "单条收款",
        "单条付款",
        "",
        "批量收款",
        "批量付款",
        "预收款",
        "预付款",
        "补差价收款",
        "补差价付款",
      ];
      // var methodList = [];
      // hisData.historys =
      var historys = hisData.historys;
      for (var i = 0; i < historys.length; i++) {
        historys[i].type_name = typeList[historys[i].type];
        // historys[i].method_name = methodList[historys[i].method]
      }
      self.hisData = hisData.historys;
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/applyWorkflow/applyHistoryData.vue